import React from "react";
import { BRAND } from "@/lib/api";

export default function Logo({ variant = "light", className = "" }) {
  const color = variant === "dark" ? "#FFFFFF" : "#090E17";
  const sub = variant === "dark" ? "rgba(255,255,255,0.6)" : "#64748B";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img src={BRAND.logo} alt="Steadfast IT Consulting" className="h-10 w-auto object-contain" />
      <div className="leading-none">
        <div className="font-display font-black text-[15px] tracking-tight" style={{ color }}>
          Steadfast Learning Hub
        </div>
        <div className="text-[10px] font-semibold tracking-[0.22em] uppercase mt-0.5" style={{ color: sub }}>
          Unified LMS
        </div>
      </div>
    </div>
  );
}
